import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
/**
 * Field label: 12px/600 on `--fg` (research/design-system.md Tier 1).
 * Required-asterisk and control wiring belong to `FormField` (Tier 2).
 */
export function Label({ className, ...props }) {
    return _jsx("label", { className: cn('block text-[12px] font-semibold leading-4 text-fg', className), ...props });
}
/**
 * Uppercase micro-label: 10.5px/700, letter-spacing .05em, `--fg-subtle`
 * (the tokens `text-micro` scale) — nav groups, table headers, form sections.
 */
export function Eyebrow({ className, ...props }) {
    return _jsx("span", { className: cn('inline-block text-micro uppercase text-fg-subtle', className), ...props });
}
//# sourceMappingURL=Label.js.map